"use client";

import type { TocItem } from "@/hooks/useTableOfContents";
import { useJsonTranslation } from "@/hooks/useJsonTranslation";
import { cn } from "@/lib/utils";

interface TableOfContentsProps {
  items: TocItem[];
  activeId: string;
}

export function TableOfContents({ items, activeId }: TableOfContentsProps) {
  const { t } = useJsonTranslation("Blog");
  if (items.length === 0) return null;

  return (
    <nav aria-label={t("labels.tableOfContents")} className="space-y-0.5">
      <p className="text-muted-foreground/60 mb-3 text-[11px] font-semibold tracking-widest uppercase">
        {t("labels.onThisPage")}
      </p>
      {items.map((item) => (
        <a
          key={item.id}
          href={`#${item.id}`}
          onClick={(e) => {
            e.preventDefault();
            document.getElementById(item.id)?.scrollIntoView({
              behavior: "smooth",
            });
          }}
          data-level={item.level}
          className={cn(
            "blog-toc-link",
            "line-clamp-2",
            activeId === item.id && "active"
          )}
        >
          {item.text}
        </a>
      ))}
    </nav>
  );
}
